import { render } from "./SearchResultCard.vue?vue&type=template&id=98a4db7a&scoped=true"
import script from "./SearchResultCard.vue?vue&type=script&lang=js"
export * from "./SearchResultCard.vue?vue&type=script&lang=js"

import "./SearchResultCard.vue?vue&type=style&index=0&id=98a4db7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98a4db7a"]])

export default __exports__